module.exports = __webpack_public_path__ + "static/Gilroy-ExtraBold-8c5d0a7a135bac6c5d2065c277ab9a63.woff2";